import BaseComponent from "@js/components/base_component.jsx";

import MuiUserRolesTable from "@js/components/mui/user_roles/table.jsx";

class MuiSubAccountsForm extends BaseComponent {

  static defaultProps = {
    editing: true,
  };

  constructor(props) {
    super(props);

    this.state = {
      accessAllClientIDs: this.props.entity.access_all_client_ids,
      accessAllFromDomains: this.props.entity.access_all_from_domains,
    };
  }

  render() {
    return (
      <div>
        <ErrorBanner entity={ this.props.entity } />

        {
          this.props.is_master_user &&
            <Panel heading="account_details">
              <div className="form-horizontal">

                <InputField
                  object={ this.props.entity }
                  type="mui_sub_account"
                  field="name"
                  editing={ this.props.editing }
                />

                <CheckboxField
                  label={ I18n.t("phrases.limit_access_to_campaigns_by_client_id") }
                  onChange={ (val) => this.setState({ accessAllClientIDs: !val }) }
                  editing={ this.props.editing }
                  name="mui_sub_account[access_all_client_ids]"
                  checked={ !this.state.accessAllClientIDs }
                  value={ "0" }
                  uncheckedValue={ "1" }
                />

                {
                  !this.state.accessAllClientIDs &&
                    <InputField
                      object={ this.props.entity }
                      type="mui_sub_account"
                      field="access_client_ids_list"
                      editing={ this.props.editing }
                      multiline={ true }
                    />
                }

                <CheckboxField
                  label={ I18n.t("phrases.limit_access_to_campaigns_by_from_address_domain") }
                  onChange={ (val) => this.setState({ accessAllFromDomains: !val }) }
                  editing={ this.props.editing }
                  name="mui_sub_account[access_all_from_domains]"
                  checked={ !this.state.accessAllFromDomains }
                  value={ "0" }
                  uncheckedValue={ "1" }
                />

                {
                  !this.state.accessAllFromDomains &&
                    <InputField
                      object={ this.props.entity }
                      type="mui_sub_account"
                      field="access_from_domains_list"
                      editing={ this.props.editing }
                      multiline={ true }
                    />
                }

              </div>
            </Panel>
        }

        {
          this.props.editing && this.props.entity.id == null &&
            <Panel heading="account_admin">
              <div className="form-horizontal">
                <InputField
                  object={ this.props.entity }
                  type="mui_sub_account"
                  field="new_account_admin_name"
                  editing={ this.props.editing }
                />
                <InputField
                  object={ this.props.entity }
                  type="mui_sub_account"
                  field="new_account_admin_email"
                  editing={ this.props.editing }
                />
              </div>
            </Panel>
        }

        {
          !this.props.editing &&
            <Panel heading="users">
              <MuiUserRolesTable
                users={ this.props.entity.users }
                is_index={ false }
              />
              <div className="text-right">
                <ButtonAdd href={ Routes.new_mui_sub_account_user_role_path(this.props.entity.id, { return_to: window.location.href }) }>
                  Add User
                </ButtonAdd>
              </div>
            </Panel>
        }
      </div>
    );
  }

}

export default MuiSubAccountsForm;
